import {createStore, compose, applyMiddleware} from 'redux';

import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';

const DEBUG = process.env.NODE_ENV !== 'production';

export default function createReduxStore(reducer) {
    // link in redux devTools if available
    const composeEnhancers =
        typeof window === 'object' && DEBUG &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    const middleware = [thunkMiddleware];

    // add any debug only middleware's
    if (DEBUG) {
        const logger = createLogger({
            diff: true,
            collapsed: true,
            duration: true,
        });
        middleware.push(logger);
    }

    const enhancer = composeEnhancers(
        applyMiddleware(...middleware),
    );

    return createStore(reducer, enhancer);
}



// WEBPACK FOOTER //
// ./src/configureStore.js